import { map } from 'lodash/fp';
import { useCallback } from 'react';
import { useFormikContext } from 'formik';

import { ContentWrapper, ScaleContainer } from './styles';
import { ModalComponentProps } from '../../../../../../components/embedded-widget/types';
import { SCALE_LABEL } from '../../../../../../ahm-constants/ui';
import { SCALE_OPTIONS } from '../../../../../../models/customer/constants';
import { StyledHeading, StyledJourneyButton } from '../styles';
import mapScaleToIncomeType from '../../../../../../utils/map-scale-to-income-type';

const ScaleSelector = ({ setIsModalOpen }: ModalComponentProps) => {
  const { setFieldValue } = useFormikContext();

  const setScaleHandler = useCallback(
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Parameter 'scale' implicitly has an 'any' type.
    (scale) => {
      setFieldValue('scale', scale);
      setFieldValue('incomeType', mapScaleToIncomeType(scale as string));
      setIsModalOpen(false);
    },
    [setFieldValue, setIsModalOpen],
  );

  return (
    <ContentWrapper>
      <StyledHeading looksLike="h5">Please select who this cover is for.</StyledHeading>
      <ScaleContainer>
        {map(
          (scale) => (
            <StyledJourneyButton key={scale} onClick={() => setScaleHandler(scale)}>
              {`${SCALE_LABEL[scale]}`}
            </StyledJourneyButton>
          ),
          SCALE_OPTIONS,
        )}
      </ScaleContainer>
    </ContentWrapper>
  );
};

export default ScaleSelector;
